import React, {Fragment, useState} from 'react';
import cn from 'classnames';
import Tooltip from "../Tooltip";

const CopyToClipboard = ({ data, className = '', children }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [fade, setFade] = useState(false);

  const setClipboard = text => {
    try {
      const type = "text/plain";
      const blob = new Blob([text], { type });
      const clipboardItem = new ClipboardItem({ [type]: blob });
      navigator.clipboard.write([clipboardItem]).then(() => {
      }).catch((error) => {
        console.error('Failed to copy to clipboard:', error);
      });
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
    }
  };

  const handleCopy = () => {
    setClipboard(data);
    setShowPopup(true);

    setTimeout(
      () => {
        setShowPopup(false);
        setFade(false)
      }, 3000);
    setTimeout(() => setFade(true), 0);
  };

  return (
    <Tooltip tooltip='My personal calendar link' data-tooltip-left={1}>
      <div className={'copy-to-clipboard'}>
        <button onClick={handleCopy} className={cn('copy-button', className)}>
          {children}
        </button>
        {showPopup && (
          <div className={cn("-copy -popup", {'-fade': fade})}>
            Copied!
          </div>
        )}
        <style>{`
          .copy-to-clipboard {
            position: relative;
            display: inline-block;
          }
  
          .-popup {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 5px;
            padding: 5px 10px;
            background: #000;
            color: #fff;
            border-radius: 4px;
            font-size: 12px;
            opacity: 1;
            transition: opacity 3s ease-in-out, top 3s ease-in-out;
          }
  
          .-popup.-fade {
            top: -40px;
            opacity: 0;
          }
        `}</style>
      </div>
    </Tooltip>
  );
};

export default CopyToClipboard;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Button/ButtonCopyToClipboard.js